import type { IxcAssetsV1AssetKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const ASSET_BASE_PATH = getResolvedPath('/asset');

export const getAssetPath: EntityPathBuilder<IxcAssetsV1AssetKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ASSET_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId) {
        return undefined;
      }

      return getResolvedPath(`${ASSET_BASE_PATH}/$assetId`, context?.keys);
    }
  }
};

export function getAssetDetailPath(assetId: string | undefined) {
  if (!assetId) {
    return undefined;
  }

  return getAssetPath({ kind: 'detail', keys: { assetId } });
}

export function getAssetMarketDataPath(assetId: string | undefined) {
  if (!assetId) {
    return undefined;
  }

  return getResolvedPath(`${ASSET_BASE_PATH}/$assetId/market-data`, { assetId });
}

export function getAssetFilingsPath(assetId: string | undefined) {
  if (!assetId) {
    return undefined;
  }

  return getResolvedPath(`${ASSET_BASE_PATH}/$assetId/filings`, { assetId });
}
